import * as React from 'react';

export const LoyaltySymbol = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.4375 18.3332C10.4375 18.3332 11.5521 15.8019 13.6773 13.6751C15.8026 11.5483 18.3322 10.4385 18.3322 10.4385C10.4594 10.4385 10.443 10.4603 10.443 18.3332H10.4375Z"
      fill="#DC0069"
    />
    <path
      d="M9.5625 18.3332C9.5625 18.3332 8.44795 15.8019 6.32265 13.6751C4.19736 11.5483 1.66776 10.4385 1.66776 10.4385C9.54065 10.4385 9.55704 10.4603 9.55704 18.3332H9.5625Z"
      fill="#DC0069"
    />
    <path
      d="M10.4375 1.66699C10.4375 1.66699 11.5521 4.19834 13.6773 6.32511C15.8026 8.45187 18.3322 9.56173 18.3322 9.56173C10.4594 9.56173 10.443 9.53986 10.443 1.66699H10.4375Z"
      fill="#DC0069"
    />
    <path
      d="M9.5625 1.66699C9.5625 1.66699 8.44795 4.19834 6.32265 6.32511C4.19736 8.45187 1.66776 9.56173 1.66776 9.56173C9.54065 9.56173 9.55704 9.53986 9.55704 1.66699H9.5625Z"
      fill="#DC0069"
    />
  </svg>
);
